import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';

import landingPageQuery from './query.graphql';

const LandingPage = loadable(
  () => import(/* webpackChunkName: "landing-page" */ './landing-page'),
  {
    fallback: <Loader />,
  }
);

LandingPage.graphQL = landingPageQuery;

LandingPage.variables = ({ marketCode, featureToggle }) => {
  const expertsEnabled = ['se'].includes(marketCode);
  const skip = featureToggle >= 1;

  return {
    experts: expertsEnabled,
    skip,
  };
};

export default LandingPage;
